import script from "./sensitive-file-detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./sensitive-file-detail.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__